import React from "react";

const labelStyle = {
  fontSize: "15.5px",
  fontWeight: 500,
  color: "#223",
  marginBottom: 2,
  display: "block"
};

const inputStyle = {
  fontSize: 16,
  padding: "11px 9px",
  borderRadius: 6,
  border: "1px solid #bbb",
  marginBottom: 2,
  width: "100%"
};

const textareaStyle = {
  ...inputStyle,
  minHeight: 70,
  resize: "vertical"
};

const helpStyle = {
  color: "#666",
  fontSize: 13,
  margin: "3px 0 9px 1px"
};

const cardStyle = {
  maxWidth: 500,
  margin: "0 auto",
  background: "#fff",
  borderRadius: 12,
  boxShadow: "0 1px 8px #e3e9eb66",
  padding: "22px 16px 20px 16px"
};

function ReviewForm({ formData = {}, setFormData }) {
  const review = formData.review || {};
  const date = review.date || "";
  const reason = review.reason || "";
  const followUp = review.followUp || "";

  const handleFieldChange = (field, value) => {
    setFormData({
      ...formData,
      review: {
        ...review,
        [field]: value
      }
    });
  };

  return (
    <div className="fra-card fra-review-card" style={cardStyle}>
      <fieldset className="fra-fieldset">
        <legend className="fra-legend" style={{ fontSize: 20, fontWeight: 700, color: "#236b50" }}>
          Review / Follow-up
        </legend>
        <div className="fra-form-group">
          <label htmlFor="review-date" style={labelStyle}>
            Review Date
          </label>
          <input
            id="review-date"
            type="date"
            value={date}
            onChange={e => handleFieldChange("date", e.target.value)}
            placeholder="Select review date"
            style={inputStyle}
          />
          <div style={helpStyle}>Select the date for the next scheduled review or follow-up.</div>
        </div>
        <div className="fra-form-group">
          <label htmlFor="review-reason" style={labelStyle}>
            Reason for Review
          </label>
          <input
            id="review-reason"
            value={reason}
            onChange={e => handleFieldChange("reason", e.target.value)}
            placeholder="e.g. Scheduled, After Incident, Major Change..."
            style={inputStyle}
          />
          <div style={helpStyle}>E.g. annual review, following incident, significant change, request, etc.</div>
        </div>
        <div className="fra-form-group">
          <label htmlFor="review-followup" style={labelStyle}>
            Follow Up Actions / Strategy
          </label>
          <textarea
            id="review-followup"
            value={followUp}
            onChange={e => handleFieldChange("followUp", e.target.value)}
            placeholder="Describe the required follow-up actions, who is responsible, and any deadlines."
            style={textareaStyle}
            rows={3}
          />
          <div style={helpStyle}>Summarise any actions, strategies, or notes from this review or audit.</div>
        </div>
      </fieldset>
      <style>{`
        @media (max-width: 600px) {
          .fra-review-card {
            padding: 10px 5vw 13px 5vw !important;
            min-width: 0;
            box-shadow: 0 0.5px 5px #e5eaea77;
            border-radius: 8px !important;
          }
          .fra-fieldset {
            padding: 0 !important;
          }
          .fra-form-group label,
          .fra-form-group input,
          .fra-form-group textarea {
            font-size: 15px !important;
          }
        }
      `}</style>
    </div>
  );
}

export default ReviewForm;
